import { generateOneLinkUrl } from '@cian/appsflyer-onelink';
import { FullscreenBanner } from '@cian/mobile-banner-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackClickOnBanner, trackShowBanner, trackOnCloseBanner } from './tracking';
import { IApplicationState } from '../../types/redux';
import { useApplicationContext } from '../ApplicationContext';

export function MobileBannerContainer() {
  const { config } = useApplicationContext();
  const mobileBannerEnabled = config.get<boolean>('mobileBanner.enabled');
  const [url, setUrl] = React.useState<string | null>(config.get<string>('mobileBanner.browserUrl') || null);
  const platform = useSelector((state: IApplicationState) => state.page.platform);
  const halfScreenIsViewed = useSelector((state: IApplicationState) => state.halfScreenBanner.isViewed);

  React.useEffect(() => {
    setUrl(generateOneLinkUrl(url, 'mobile_site'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!mobileBannerEnabled || !platform || !url || halfScreenIsViewed) {
    return null;
  }

  const handleBannerClick = () => {
    trackClickOnBanner(platform);
  };

  const handleCloseBanner = () => {
    trackOnCloseBanner(platform);
  };

  const handleShowBanner = () => {
    trackShowBanner(platform);
  };

  return (
    <FullscreenBanner
      url={url}
      caShowBanner={handleShowBanner}
      caClickOnBanner={handleBannerClick}
      caCloseBanner={handleCloseBanner}
    />
  );
}
